import { Button, Flex, Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'
import { useSocPublicImageBucketUrl } from 'src/hooks/useSocPublicImageBucketUrl'
import { CardTypeTile } from '../../CardPreview/components/CardTypeTile'
import { CardType } from 'src/graphql/generated/graphql'

type ThreeDayTrialModalProps = {
  onFinish: () => void
}

export const ThreeDayTrialModal = (props: ThreeDayTrialModalProps) => {
  const prizeImageUrl = useSocPublicImageBucketUrl('Prize.png')
  const goodVibes3dCardImageUrl = useSocPublicImageBucketUrl(
    'GoodVibes3dCard.png',
  )

  return (
    <Flex
      width="100%"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
    >
      <Flex columnGap="x1">
        <img
          style={{
            width: '80px',
            height: '80px',
            marginBottom: '12px',
          }}
          src={prizeImageUrl}
          alt="Trophy"
        />
        <Flex
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          rowGap="x1"
        >
          <Text
            type="body"
            weight="bold"
            content="Claim My Free Cards"
            alignment="center"
            style={{
              color: '#2A2A2A',
              fontWeight: 700,
              fontSize: '32px',
            }}
          />
          <Text
            type="body"
            weight="thin"
            content="Your 3-Day Pass: 3 Digital, 1 Printed, All Free"
            alignment="center"
            inset={{ horizontal: '8px' }}
            style={{
              color: '#2A2A2A',
            }}
          />
        </Flex>
      </Flex>
      <Flex
        flexDirection="column"
        style={{
          background: 'white',
          width: '100%',
          height: '100%',
          padding: '12px',
          borderRadius: '8px',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Flex
          flexDirection="row"
          columnGap="x2"
          width="100%"
          justifyContent="center"
          maxWidth="300px"
        >
          <CardTypeTile
            title="3 Free Digital Cards"
            cardType={CardType.Flatcard}
            isSelected={false}
            backgroundColor={undefined}
            isHorizontal={false}
            isDigital={true}
            imageUrl={goodVibes3dCardImageUrl}
            onSelect={() => {}}
          />
          <CardTypeTile
            title="1 Free Printed Card"
            cardType={CardType.Flatcard}
            backgroundColor={undefined}
            isSelected={false}
            isHorizontal={false}
            imageUrl={goodVibes3dCardImageUrl}
            onSelect={() => {}}
          />
        </Flex>
      </Flex>
      <Flex
        width="100%"
        justifyContent="center"
        flexDirection="column"
        alignItems="center"
      >
        <Text
          type="body"
          weight="thin"
          content="Finish setting up your account to claim your reward"
          style={{
            color: '#2A2A2A',
            padding: '8px',
          }}
        />
        <Flex
          width="100%"
          maxWidth="520px"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          inset={{ top: '12px' }}
        >
          <Button
            backgroundColorOverride="#444444"
            size="medium"
            fullWidth
            onClick={() => {
              props.onFinish()
            }}
            title="Claim 3-Day Trial"
          />
        </Flex>
      </Flex>
    </Flex>
  )
}
